import { Box, Container, Paper, Typography } from '@mui/material';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import './App.css';
import Footer from './Footer';
import LawAppBar from './LawAppBar';
import { getAllPressReleases } from './press/index';
import './Press.css';

export default function Press() {
    const [cookies] = useCookies(['given_name', 'userid', 'picture', 'email', 'credential']);
    const navigate = useNavigate();
    const pressReleases = getAllPressReleases();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        });
    };

    return (
        <div className="App">
            <LawAppBar cookies={cookies} />
            <Container
                maxWidth="lg"
                sx={{
                    padding: { xs: '20px', sm: '40px' },
                    marginTop: '40px',
                    marginBottom: '60px',
                    textAlign: 'left'
                }}
            >
                {/* Header Section */}
                <Box sx={{ textAlign: 'center', marginBottom: '48px' }}>
                    <Typography
                        variant="h3"
                        component="h1"
                        gutterBottom
                        sx={{
                            color: 'var(--text-primary)',
                            fontWeight: 400,
                            fontSize: { xs: '2rem', sm: '2.8rem', md: '3.2rem' },
                            marginBottom: '1rem',
                            letterSpacing: '-0.02em',
                            lineHeight: 1.2
                        }}
                    >
                        Press Releases
                    </Typography>
                </Box>

                {/* Press Releases List */}
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
                    {pressReleases.map((pressRelease) => (
                        <Paper
                            key={pressRelease.id}
                            elevation={0}
                            onClick={() => navigate(`/press/${pressRelease.slug}`)}
                            sx={{
                                padding: { xs: '24px', sm: '32px' },
                                borderRadius: '8px',
                                boxShadow: 'var(--shadow-light)',
                                border: '1px solid var(--border-color)',
                                cursor: 'pointer',
                                transition: 'all 0.2s ease',
                                textAlign: 'left',
                                '&:hover': {
                                    boxShadow: 'var(--shadow-medium)',
                                    borderColor: 'var(--accent-color)',
                                    transform: 'translateY(-2px)'
                                }
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    color: 'var(--text-secondary)',
                                    fontSize: { xs: '0.85rem', sm: '0.9rem' },
                                    fontWeight: 500,
                                    marginBottom: '12px'
                                }}
                            >
                                {formatDate(pressRelease.date)}
                            </Typography>
                            <Typography
                                variant="h5"
                                component="h2"
                                sx={{
                                    color: 'var(--text-primary)',
                                    fontWeight: 500,
                                    fontSize: { xs: '1.3rem', sm: '1.5rem' },
                                    marginBottom: '12px',
                                    letterSpacing: '-0.01em'
                                }}
                            >
                                {pressRelease.title}
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: 'var(--text-secondary)',
                                    fontSize: { xs: '0.95rem', sm: '1rem' },
                                    lineHeight: 1.6
                                }}
                            >
                                {pressRelease.summary}
                            </Typography>
                        </Paper>
                    ))}
                </Box>

                {pressReleases.length === 0 && (
                    <Box sx={{ textAlign: 'center', padding: '60px 20px' }}>
                        <Typography
                            variant="body1"
                            sx={{
                                color: 'var(--text-secondary)',
                                fontSize: '1rem'
                            }}
                        >
                            No press releases available at this time.
                        </Typography>
                    </Box>
                )}
            </Container>
            <Footer />
        </div>
    );
}

